import Vue from 'vue';
import VueI18n from 'vue-i18n';
import * as Sentry from '@sentry/browser';
// import VueLazyload from 'vue-lazyload';
import App from './App.vue';
import router from './router';
import store from './store';
import * as i18nEn from './lang/en';
import * as i18nZhCn from './lang/zh-cn';
import copyText from './utils/copy-text';
import errCapture from './utils/err-captrue';
import { checkToken, reportChannelReferrer } from '@/api/user.js';
import { getChannelReferrer, clearChannelReferrer } from './utils/channel-tracker';

Vue.use(VueI18n)
  .use(errCapture)
  .use(copyText);

if (window.__TIGA_CONFIG__ && window.__TIGA_CONFIG__.sentryUrl) {
  Sentry.init({
    dsn: window.__TIGA_CONFIG__.sentryUrl,
    beforeSend(event, hint) {
      const err = hint.originalException;
      const filterCode = [
        // '40000',
        // '40001',
        // '40002',
        // '40003',
        // '40004',
        '1048',
        'ECONNABORTED',
        'NETWORKERROR',
      ];
      if (filterCode.includes(String(err && err.code))) {
        return null;
      }
      if (
        ['40000', '40001', '40002', '40003', '40004'].includes(
          String(err && err.code),
        )
      ) {
        err.u_id = store.state.userInfo.id;
      }
      return event;
    },
  });
}
// Vue.use(VueLazyload, {
//   preload: 1,
//   loading: 'https://assets.exincdn.com/exinlocal/logo/exinlocal.png',
//   error: 'https://assets.exincdn.com/exinlocal/logo/exinlocal.png',
//   attempt: 1,
// });

Vue.config.productionTip = false;
Vue.config.errorHandler = function(err, vm) {
  if (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
  if (err && vm.$sendErr) {
    vm.$sendErr(err);
  }
};

store.commit('loadUserInfoFromLocal');
const lang = store.state.userInfo.lang || getLang();
const langMainObj = {
  'zh-cn': 'zh',
  en: 'en',
};
const langMain = store.state.userInfo.langMain || langMainObj[lang] || 'en';

store.commit('setNavLang', {
  lang: lang,
  langMain: langMain,
});

const i18n = new VueI18n({
  locale: lang,
  fallbackLocale: 'en',
  messages: {
    en: i18nEn,
    'zh-cn': i18nZhCn,
  },
});
Vue.prototype.$t = function(key) {
  var values = [],
    len = arguments.length - 1;
  while (len-- > 0) values[len] = arguments[len + 1];
  // 可能拿不到 this 导致的报错
  var i18n = this.$i18n || window.vueInstance.$i18n;
  return i18n._t.apply(
    i18n,
    [key, i18n.locale, i18n._getMessages(), this].concat(values),
  );
};

let promise = Promise.resolve();
let error = null;
if (store.state.isLogin) {
  // 验证token 是否可用，再挂载
  promise = new Promise(resolve => {
    checkToken()
      .then(() => {
        // 登录成功后，检查并上报渠道信息
        const channelId = getChannelReferrer();
        if (channelId) {
          reportChannelReferrer(channelId)
            .then(() => {
              // eslint-disable-next-line no-console
              console.log('渠道信息上报成功:', channelId);
              // 上报成功后清除缓存
              clearChannelReferrer();
            }).catch(err => {
              // eslint-disable-next-line no-console
              console.error('渠道信息上报失败:', err);
              // 上报失败不影响正常流程，保留缓存待下次重试
            });
        }
        
        let loginFrom = window.localStorage.getItem('loginFrom');
        if (loginFrom) {
          window.localStorage.removeItem('loginFrom');
          if (loginFrom !== router.currentRoute.fullPath) {
            router.push(loginFrom);
          }
        }
      })
      .finally(resolve);
  });
}

promise.finally(() => {
  const vue = new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
  }).$mount('#app');

  vue.countries = require('i18n-iso-countries');
  // 默认语言切换
  vue.countries.registerLocale(
    require(`i18n-iso-countries/langs/${langMain}.json`),
  );

  window.vueInstance = vue;

  if (error) {
    vue.$sendErr(error);
  }
});

function getLang() {
  // 键均为小写, 下划线替换为短横
  const navLang = (window.navigator.language || '')
    .toLowerCase()
    .replace('_', '-');
  const mainLangDic = {
    // 繁体暂时使用简中
    zh: 'zh-cn',
    en: 'en',
  };
  const langDic = {
    // 此处定义单独定制的语言
    'en-us': 'en',
  };
  if (langDic[navLang]) {
    return langDic[navLang];
  }
  //取短横前一段作为主语言
  const mainLang = navLang.split('-')[0];
  if (mainLangDic[mainLang]) {
    return mainLangDic[mainLang];
  }
  //fallback
  return 'en';
}

Vue.directive('input-mode', {
  inserted: function(el, binding) {
    let target = el;
    if (target.tagName.toUpperCase() !== 'input') {
      target = target.querySelector('input');
    }
    if (!target || !binding.value) return;
    target.setAttribute('inputmode', binding.value);
  },
});
